(function ($, Drupal, drupalSettings) {

  'use strict';

  Drupal.behaviors.mpGridSlider = {
    attach: function (context, settings) {
      if (typeof settings.mp_paragraphs === 'undefined') return;
      for (var id in settings.mp_paragraphs.mp_grid_slider) {
        var slider_settings = settings.mp_paragraphs.mp_grid_slider[id],
          $slider = $('#' + id, context)
        ;

        if ($slider.length === 0) break;

        if (slider_settings.enable_arrows) {
          $slider.addClass('slick-arrowed');
        }

        $(once('slick', $slider, context))
          .on('init', function(slick) {
            toggleHasArrowsClass();
          })
          .on('breakpoint', function(event, slick) {
            toggleHasArrowsClass();
          })
          .slick({
            mobileFirst: true,
            infinite: false,
            dots: slider_settings.enable_dots,
            arrows: slider_settings.enable_arrows,
            slidesToShow: slider_settings.items_per_slide_xs,
            slidesToScroll: slider_settings.items_per_slide_xs,
            responsive: [
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: slider_settings.items_per_slide_md,
                  slidesToScroll: slider_settings.items_per_slide_md
                }
              },
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: slider_settings.items_per_slide_lg,
                  slidesToScroll: slider_settings.items_per_slide_lg
                }
              }
            ]
          })
        ;

        function toggleHasArrowsClass() {
          $slider.toggleClass('slick-has-arrows', $slider.find('.slick-prev').length ? true : false);
        }

      }
    }
  };

})(jQuery, Drupal, drupalSettings);
